import { memo } from 'react';
import { FallbackLogoIcon, TopSpacedContainer } from './styles';

export const FallbackLoading = () => {
  return (
    <TopSpacedContainer data-testid="fallback">
      <FallbackLogoIcon />
    </TopSpacedContainer>
  );
};

export default memo(FallbackLoading);
